import axiosInstance from "../Axios/axiosInstance";

const getAllMailConfigs = async () => {
  return await axiosInstance.get("/mailConfig/");
};

const getMailConfigById = async (id) => {
  return await axiosInstance.get(`/mailConfig/${id}`);
};

const addMailConfig = async (data) => {
  console.log(data);
  return await axiosInstance.post("/mailConfig/", data);
};

const editMailConfig = async (id, data) => {
  return await axiosInstance.put(`/mailConfig/${id}`, data);
};

const deleteMailConfig = async (id) => {
  return await axiosInstance.delete(`/mailConfig/${id}`);
};

export default {
  getAllMailConfigs,
  getMailConfigById,
  addMailConfig,
  editMailConfig,
  deleteMailConfig,
};
